module.exports = __webpack_public_path__ + "static/logo-ore-7222b2c1ded962fff27694f47a8a48dd.png";